import { render, staticRenderFns } from "./setmeal.vue?vue&type=template&id=0ccf1e02&scoped=true&"
import script from "./setmeal.vue?vue&type=script&lang=js&"
export * from "./setmeal.vue?vue&type=script&lang=js&"
import style0 from "./setmeal.vue?vue&type=style&index=0&id=0ccf1e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf1e02",
  null
  
)

export default component.exports